module.exports = __webpack_public_path__ + "images/help/video-files-15f6b32b3e617e0ed7be032d4039caeb.png";